import {
  jb_richtext_css_default
} from "./chunk.WZYGBNQV.js";
import {
  Spaceable,
  initializeLink
} from "./chunk.3FKBYJ4V.js";
import {
  to
} from "./chunk.BMHRULEY.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ChangesBackgroundColor
} from "./chunk.A2J677GQ.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-richtext/jb-richtext.ts
var JbRichtext = class extends Initiable(ChangesBackgroundColor(Spaceable(r))) {
  async firstUpdated() {
    const firstChildElement = [...Array.from(this.childNodes)].find((node) => node.nodeType === 1);
    if (firstChildElement === void 0) {
      return;
    }
    const slot = firstChildElement.assignedSlot;
    slot.append(...Array.from(this.childNodes));
    slot.querySelectorAll("table").forEach((table) => {
      const originalTable = table.cloneNode(true);
      table.replaceWith(
        this._wrapTable(
          originalTable,
          table.previousElementSibling,
          table.nextElementSibling
        )
      );
    });
    slot.querySelectorAll("a").forEach((link) => {
      initializeLink(link);
      link.dataset.flyPadding = "0";
    });
  }
  _getContentSpacingProperties() {
    return { grid: "legacy", type: "text" };
  }
  _wrapTable(table, preface, footnotes) {
    const tableWrapper = document.createElement("div");
    tableWrapper.classList.add("tablewrapper");
    if (preface?.classList.contains("preface")) {
      tableWrapper.appendChild(preface);
    }
    if (footnotes?.tagName === "FIGCAPTION") {
      tableWrapper.appendChild(footnotes);
    }
    tableWrapper.appendChild(table);
    if (footnotes?.classList.contains("footnotes")) {
      tableWrapper.appendChild(footnotes);
    }
    return tableWrapper;
  }
  render() {
    return ke`<slot class="${to(this.size)}"></slot>`;
  }
};
JbRichtext.styles = [reset_css_default, jb_richtext_css_default];
__decorateClass([
  n()
], JbRichtext.prototype, "size", 2);
JbRichtext = __decorateClass([
  customElement("jb-richtext")
], JbRichtext);

export {
  JbRichtext
};
